'use client';

import { BaseCardProps } from './types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

export const cardTransitions = css`
  @media (prefers-reduced-motion: no-preference) {
    transition: all 0.2s ease-in-out;
  }
`;

export const BaseCard = styled.div<BaseCardProps>`
  border-radius: ${(p) => p.theme.radius.containerRadius};
  background: ${(p) => p.theme.midwestColors.neutralLightWeak};
  ${cardTransitions}
  ${(p) =>
    p.raised &&
    css`
      box-shadow: ${(p) => p.theme.shadow.sm};
    `}

  display: flex;
  padding: ${(p) => p.theme.spacing.containerPaddingLg};
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  overflow: auto;
`;

/**
 ```jsx
 import { MDSBaseCard } from '@midwest/web/card';
 ```
 * The Base Card component is just a standard blank card with no card templates or components included. For card usage with built in components see the [Product Card](https://midwest-storybook.icweb.stage.aws.tfcloud.corp/?path=/docs/thrivent-web-components-product-card--docs).
 */
export const MDSBaseCard = forwardRef<HTMLDivElement, BaseCardProps>(
  ({ raised = true, ...rest }: BaseCardProps, ref) => {
    return <BaseCard raised={raised} ref={ref} {...rest} />;
  },
);

MDSBaseCard.displayName = 'MDSBaseCard';
